/** Sort key for class names: LKG, UKG, then 1A, 1B, 2A, … 10Z */
function parseDivisionSortKey(name) {
  const s = String(name ?? '').trim().toUpperCase();
  if (!s) return { tier: 99, grade: 999, division: '' };

  const preschool = s.match(/^(LKG|UKG)\s+([A-Z0-9]+)$/);
  if (preschool) {
    return { tier: preschool[1] === 'LKG' ? 0 : 1, grade: 0, division: preschool[2] };
  }

  const compact = s.match(/^(\d{1,2})[-\s]?([A-Z0-9]+)$/);
  if (compact) {
    return { tier: 2, grade: parseInt(compact[1], 10), division: compact[2] };
  }

  return { tier: 99, grade: 999, division: s };
}

export function compareDivisionNames(a, b) {
  const nameA = typeof a === 'string' ? a : a?.division_name;
  const nameB = typeof b === 'string' ? b : b?.division_name;
  const ka = parseDivisionSortKey(nameA);
  const kb = parseDivisionSortKey(nameB);
  if (ka.tier !== kb.tier) return ka.tier - kb.tier;
  if (ka.grade !== kb.grade) return ka.grade - kb.grade;
  return ka.division.localeCompare(kb.division, undefined, { numeric: true });
}

export function sortByDivisionName(items) {
  return [...items].sort(compareDivisionNames);
}
